import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TableLoader from "components/Common/Loader";
import CustomPagination from "components/Common/CustomPagination";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { formatDateBroker } from "helpers/formatDate";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Badge from "components/Common/Badge";
import { useDispatch } from "react-redux";
import { fetchCashbackStart } from "store/transactions/cashback/action";

// ...existing code...
export default function CashbackTable(props) {
  const { cashback: { data, loading, paginationResult }, selectedValues } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const loadCashbackTransactions = (page, limit) => {
    dispatch(fetchCashbackStart({
      ...selectedValues,
      page,
      limit,
    }));
  };
  useEffect(() => {
    loadCashbackTransactions(1, sizePerPage);
  }, [sizePerPage]);
  const columns = [
    {
      text: t("Client"),
      dataField: "Client",
      formatter: (val) => {
        return <Link to={`/clients/${val.customerId._id}/profile`}>{`${val.customerId.firstName} ${val.customerId.lastName}`}</Link>;
      }
    },
    {
      text: t("Account"),
      dataField: "Account",
      formatter: (val) => {
        const { logins = [] } = val?.rawData;
        return `${logins?.[logins.length - 1] || "-"}`;
      }
    },
    {
      text: t("Group Path"),
      dataField: "Group Path",
      formatter: (val) => {
        return val?.rawData?.groupPath || "=";
      }
    },
    {
      text: t("Total Lots (Daily)"),
      dataField: "totalClosedLots",
      formatter: (val) => {
        return val.rawData.totalClosedLots.toFixed(2);
      }
    },
    {
      text: t("Symbol"),
      dataField: "symbol",
      formatter: (val) => {
        return val?.rawData?.symbol || "-";
      }
    },
    {
      text: t("Cashback Amount"),
      dataField: "cashbackAmount",
      formatter: (val) => {
        return `${val.rawData.cashbackAmount} USD`;
      }
    },
    {
      text: t("Date"),
      dataField: "updatedAt",
      formatter: (val) => formatDateBroker(val.updatedAt, "DD/MM/YYYY"),
    },
  ];
  const colCount = columns?.length || 1;
  return (
    <div className="mt-5" >
      <Table id="tech-companies-1" className="table table-hover">
        <Thead className="text-center table-light">
          <Tr>
            {columns.map((column, index) => (
              <Th data-priority={index} key={index}>
                {column.text}
              </Th>
            ))}
          </Tr>
        </Thead>

        <Tbody className="text-center" style={{ fontSize: "13px" }}>
          {loading && <TableLoader colSpan={colCount} />}

          {!loading ? data.length > 0 ?
            data?.map((row, rowIndex) => (
              <Tr key={rowIndex}>
                {columns.map((column, index) => (
                  <Td key={`${rowIndex}-${index}`}>
                    {column.formatter
                      ? column.formatter(row, rowIndex)
                      : row[column.dataField]}
                  </Td>
                ))}
              </Tr>
            )) : (
              <Tr style={{ height: "50vh" }}>
                <Td colSpan={colCount} className="fw-bolder text-center">
                  <h3 className="fw-bolder text-center">{t("No records")}</h3>
                </Td>
              </Tr>
            ) : null}

          <Tr>
            <Td colSpan={colCount}>
              {/* <ShowStats
                type={payload?.type}
                dateFrom={payload?.dateFrom}
                dateTo={payload?.dateTo}
                agent={payload?.agent}
              /> */}
            </Td>
          </Tr>
        </Tbody>
      </Table>
      <CustomPagination
        {...paginationResult}
        docs={data}
        setSizePerPage={setSizePerPage}
        sizePerPage={sizePerPage}
        onChange={loadCashbackTransactions}
      />
    </div>
  );
}

CashbackTable.propTypes = {
  loading: PropTypes.bool,
  docs: PropTypes.array,
  columns: PropTypes.array,
  payload: PropTypes.object,
};

CashbackTable.defaultProps = {
  loading: false,
  docs: [],
  columns: [],
  payload: {},
};
// ...existing code...